import { useEffect, useRef, useState } from "react";

export function useInfiniteScroll(callback: () => void, enabled = true) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { rootMargin: "200px 0px 200px 0px", threshold: 0 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [enabled]);

  useEffect(() => {
    if (enabled && isIntersecting) callback();
  }, [isIntersecting, enabled, callback]);

  return ref; // attach to the sentinel <div ref={ref} />
}